import { RouteObject } from "react-router-dom";
import { WorkflowProvider } from "./components/create/WorkflowContext";
import ConsumerOnboardingLandingPage from "./components/landing/landing";
import ApplicationReview from "./components/create/ApplicationReview";
import SiteInspection from "./components/create/SiteInspection";
import ApprovalPage from "./components/create/ApprovalPage";
import InstallationPage from "./components/create/InstallationPage";
import ActivationPage from "./components/create/ActivationPage/ActivationPage";

export interface ConsumerOnboardingRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: ConsumerOnboardingRoute[];
}

export const consumerOnboardingRoutes: ConsumerOnboardingRoute[] = [
  {
    path: "/cx/consumer-onboarding/",
    element: <ConsumerOnboardingLandingPage />,
  },

  {
    path: "/cx/consumer-onboarding/view/:id/:status",
    element: (
      <WorkflowProvider>
        <ApplicationReview />
      </WorkflowProvider>
    ),
  },
  {
    path: "/cx/consumer-onboarding/workflow/inspection/:consumerId/:status",
    element: (
      <WorkflowProvider>
        <SiteInspection />
      </WorkflowProvider>
    ),
  },

  {
    path: "/cx/consumer-onboarding/workflow/approval/:consumerId/:status",
    element: (
      <WorkflowProvider>
        <ApprovalPage />
      </WorkflowProvider>
    ),
  },
  {
    path: "/cx/consumer-onboarding/workflow/installation/:consumerId/:status",
    element: (
      <WorkflowProvider>
        <InstallationPage />
      </WorkflowProvider>
    ),
  },
  {
    path: "/cx/consumer-onboarding/workflow/activation/:consumerId/:status",
    element: (
      <WorkflowProvider>
        <ActivationPage />
      </WorkflowProvider>
    ),
  },
  {
    path: "/cx/consumer-onboarding/workflow/inspection/:consumerId/",
    element: (
      <WorkflowProvider>
        <SiteInspection />
      </WorkflowProvider>
    ),
  },
  {
    path: "/cx/consumer-onboarding/workflow/approval/:consumerId/",
    element: (
      <WorkflowProvider>
        <ApprovalPage />
      </WorkflowProvider>
    ),
  },
  {
    path: "/cx/consumer-onboarding/workflow/installation/:consumerId/",
    element: (
      <WorkflowProvider>
        <InstallationPage />
      </WorkflowProvider>
    ),
  },
  {
    path: "/cx/consumer-onboarding/workflow/activation/:consumerId/",
    element: (
      <WorkflowProvider>
        <ActivationPage />
      </WorkflowProvider>
    ),
  },
  {
    path: "/cx/consumer-onboarding/view/:id/",
    element: (
      <WorkflowProvider>
        <ApplicationReview />
      </WorkflowProvider>
    ),
  },
];
